import {APIMethod} from '@enums'

import {fetchData} from 'api/api'

import {CompanyRequest, CompanyResponse} from './types'

export const getCompanyById = (id: string) =>
  fetchData<undefined, CompanyResponse>({method: APIMethod.GET, url: `company/${id}`})

export const getAllCompanies = () => fetchData<undefined, CompanyResponse[]>({method: APIMethod.GET, url: 'company'})

export const createCompany = (body: CompanyRequest) =>
  fetchData<CompanyRequest, CompanyResponse>({method: APIMethod.POST, url: 'company', body})

export const updateCompany = (id: string, body: CompanyRequest) =>
  fetchData<CompanyRequest, CompanyResponse>({method: APIMethod.PUT, url: `company/${id}`, body})
